import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import Header from './components/feature/Header';
import Footer from './components/feature/Footer';
import CookieBanner from './components/feature/CookieBanner';
import ScrollToTop from './components/feature/ScrollToTop';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1 pt-20">
          <AppRoutes />
        </main>
        <Footer />
        <CookieBanner />
        <ScrollToTop />
      </div>
    </BrowserRouter>
  );
}

export default App;
